import React from 'react'
/** @jsxImportSource @emotion/react */

import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { toCurrency } from '../_helpers/pdfHelpers'
import Text from '../../../../components/pdf/Text'
import Grid from '../../../../components/pdf/Grid'

const ServiceProvidedTable = ({ servicesProvided, style }) => {
  const sumServicesProvidedPrices = servicesProvided.reduce((total, service) => total + service.price, 0)

  return (
    <>
      <Grid justify="center" style={{ padding: '0.5rem 1rem' }}>
        <Table width="100%" center style={{ border: '2px solid #333' }} color="#000">
          <TableRow style={{ backgroundColor: '#a6a6a6' }} color="#000">
            <TableCol colspan={8} color="#000">
              <Text bold size="small" align="center">
                Serviço prestado
              </Text>
            </TableCol>
            <TableCol color="#000">
              <Text bold size="small" align="center">
                Preço
              </Text>
            </TableCol>
          </TableRow>
          {servicesProvided.map(serviceProvided => {
            return (
              <>
                <TableRow color="#000" css={style}>
                  <TableCol colspan={8} color="#000">
                    <Text size="small" align="center" color="#000">
                      {serviceProvided.service}
                    </Text>
                  </TableCol>
                  <TableCol color="#000">
                    <Text size="small" align="center" color="#000">
                      {toCurrency(serviceProvided.price)}
                    </Text>
                  </TableCol>
                </TableRow>
              </>
            )
          })}
          <TableRow color="#000">
            <TableCol colspan={8} color="#000">
              <Text bold size="small" align="center">
                Total
              </Text>
            </TableCol>
            <TableCol color="#000" width="8%">
              <Text size="small" align="center">
                {toCurrency(sumServicesProvidedPrices)}
              </Text>
            </TableCol>
          </TableRow>
        </Table>
      </Grid>
    </>
  )
}

export default ServiceProvidedTable
